import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "/node_modules/react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaTrash } from "react-icons/fa";
import Select from "react-select";
import { format } from "date-fns";
import moment from "moment";

const scheduleOptions = {
  1: [
    { value: "Sunday", label: "Sunday" },
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
  ],
  2: Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  })),
};

const scheduleRepetitions = [
  { value: 0, label: "Every Day" },
  { value: 1, label: "Every Specified Day" },
  { value: 2, label: "Every Specified Date" },
  {
    value: 3,
    label: "Every Specified Date and Month",
  },
  { value: 4, label: "Every End of Month" },
  { value: 5, label: "Every End of Year" },
];

const customStyles = {
  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    padding: "0 8px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "4px",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "30px", // Sesuaikan dengan tinggi form Bootstrap
    height: "30px",
    borderRadius: "4px",
    borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Ubah warna border saat fokus
    boxShadow: state.isFocused ? "0 0 0 0.1px #7f7f7f" : base.boxShadow, // Hilangkan shadow bawaan
    "&:hover": {
      borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Warna hover
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: -2,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "170px", // Atur tinggi maksimum dropdown
    overflowY: "auto", // Tambahkan scroll jika kontennya melebihi batas
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided) => ({
    ...provided,
    padding: "4px 10px", // Atur padding agar tidak terlalu besar
  }),
};

const ScheduleTable = ({ scheduleData, setScheduleData, removeRow }) => {
  const handleChange = (index, key, value) => {
    const updatedRows = [...scheduleData];

    if (key === "startDate") {
      const newStartDate = moment(value); // Konversi string menjadi moment object
      const currentEndDate = moment(updatedRows[index].endDate); // Konversi endDate juga

      if (!updatedRows[index].endDate || newStartDate.isAfter(currentEndDate)) {
        updatedRows[index].endDate = value; // Set endDate jika startDate lebih besar atau endDate kosong
      }
    }

    if (key === "repetition") {
      updatedRows[index]["setting"] = null;
    }

    updatedRows[index][key] = value;
    setScheduleData(updatedRows);
  };

  const handleDateSelect = (index, date) => {
    if (!date) return;

    const formattedDate = format(date, "d-MMM"); // Contoh format: 5-Sep
    const updatedRows = [...scheduleData];

    updatedRows[index].setting = { value: formattedDate, label: formattedDate };

    setScheduleData(updatedRows);
  };

  const handleRemoveDate = (index) => {
    const updatedRows = [...scheduleData];
    updatedRows[index].setting = null; // Atau bisa juga `undefined`
    setScheduleData(updatedRows);
  };

  return (
    <div className="table-responsive">
      <table className="table table-bordered table-bordered table-custome">
        <thead>
          <tr className="text-white">
            <th rowSpan="2" className="text-center p-2">
              Schedule Repetition
            </th>
            <th
              rowSpan="2"
              className="text-center p-2"
              style={{ width: "15%" }}
            >
              Schedule Setting
            </th>
            <th colSpan="2" className="text-center p-2">
              Daily Operational Hour
            </th>
            <th colSpan="2" className="text-center p-2">
              Campaign Period
            </th>
            <th
              rowSpan="2"
              className="text-center p-2"
              style={{ width: "10%" }}
            >
              Estimated Capacity
            </th>
            <th rowSpan="2" className="text-center p-2">
              Action
            </th>
          </tr>
          <tr className="text-white">
            <th className="text-center p-2">Start Hour</th>
            <th className="text-center p-2">End Hour</th>
            <th className="text-center p-2">Start Date</th>
            <th className="text-center p-2">End Date</th>
          </tr>
        </thead>
        <tbody>
          {scheduleData.map((row, index) => (
            <tr key={index}>
              {/* Schedule Repetition */}
              <td className="p-2">
                <Select
                  options={scheduleRepetitions}
                  styles={customStyles}
                  value={
                    scheduleRepetitions.find(
                      (opt) => opt.value === row.repetition
                    ) || null
                  }
                  onChange={(selected) =>
                    handleChange(index, "repetition", selected.value)
                  }
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                />
              </td>

              {/* Schedule Setting */}
              <td className="p-2">
                {row.repetition === 3 ? (
                  <div className="d-flex align-items-center gap-2 custom-multi">
                    <div className="flex-grow-1">
                      <Select
                        options={row.setting || []}
                        styles={customStyles}
                        // isMulti
                        value={row.setting || []}
                        onChange={(selected) =>
                          handleRemoveDate(index, selected)
                        }
                        isClearable={false} // Tidak bisa dihapus langsung
                        isSearchable={false} // Tidak bisa mencari
                        menuIsOpen={false}
                        placeholder=""
                        components={{
                          IndicatorsContainer: () => null,
                        }}
                      />
                    </div>

                    <DatePicker
                      selected={null} // Selalu null agar tidak menampilkan tanggal terakhir yang dipilih
                      onChange={(date) => handleDateSelect(index, date)}
                      dateFormat="d-MMM"
                      placeholderText="Select Date"
                      className="mb-1"
                      customInput={
                        <a
                          className="btn btn-primary"
                          style={{
                            marginTop: "4px",
                            padding: "0.20rem 0.5rem",
                          }}
                        >
                          <FaCalendarAlt size={13} />
                        </a>
                      }
                      // multiple
                    />
                  </div>
                ) : scheduleOptions[row.repetition] ? (
                  <Select
                    options={scheduleOptions[row.repetition]}
                    styles={customStyles}
                    menuPortalTarget={document.body}
                    // isMulti
                    value={row.setting}
                    onChange={(selected) =>
                      handleChange(index, "setting", selected)
                    }
                  />
                ) : (
                  "-"
                )}
              </td>

              {/* Daily Operational Hour */}
              <td className="p-2">
                <input
                  type="time"
                  value={row.startHour}
                  onChange={(e) =>
                    handleChange(index, "startHour", e.target.value)
                  }
                  className="form-control"
                />
              </td>
              <td className="p-2">
                <input
                  type="time"
                  value={row.endHour}
                  onChange={(e) =>
                    handleChange(index, "endHour", e.target.value)
                  }
                  className="form-control"
                />
              </td>

              {/* Campaign Period */}
              <td className="p-2">
                <DatePicker
                  selected={row.startDate ? new Date(row.startDate) : null}
                  onChange={(date) => handleChange(index, "startDate", date)}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/mm/yyyy"
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" || e.key === "Delete") {
                      e.preventDefault(); // Mencegah penghapusan dengan Backspace/Delete
                    }
                  }}
                />
              </td>
              <td className="p-2">
                <DatePicker
                  selected={row.endDate ? new Date(row.endDate) : null}
                  onChange={(date) => handleChange(index, "endDate", date)}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/mm/yyyy"
                  minDate={
                    row.startDate
                      ? moment(row.startDate).add(1, "day").toDate()
                      : null
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Backspace" || e.key === "Delete") {
                      e.preventDefault(); // Mencegah penghapusan dengan Backspace/Delete
                    }
                  }}
                />
              </td>

              {/* Estimated Capacity */}
              <td className="p-2" style={{ width: "5%" }}>
                {row.estimate_cap ? row.estimate_cap : "-"}
              </td>

              {/* Action */}
              <td className="p-2 text-center">
                {scheduleData.length > 1 && (
                  <a
                    onClick={() => removeRow(index)}
                    className="btn btn-danger btn-sm"
                    title="Delete"
                  >
                    <FaTrash />
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleTable;
